import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';
import { getIntl } from '../../utils/intl';
import { getProfileCollaboratorCacheKey } from './cacheKeys';
import { useQueryErrorNotify } from '../useQueryCallbacks';

const intl = getIntl('useCollaborator', {
    loadError: 'Error loading collaborator',
});

export type UseCollaboratorArgs = {
    medicalProfileId: string;
    collaboratorId: string;
};

export type UseCollaboratorReturnValue = {
    collaborator: APITypes.medicalProfileService.MedicalProfileCollaborator | null;
    isLoading: boolean;
};

export const useCollaborator = (args: UseCollaboratorArgs): UseCollaboratorReturnValue => {
    const { medicalProfileId, collaboratorId } = args;
    const collaborator = useQuery({
        queryKey: getProfileCollaboratorCacheKey(medicalProfileId, collaboratorId),
        queryFn: async () => {
            return appAPI.get<APITypes.medicalProfileService.GetMedicalProfileCollaboratorResponse>(
                urls.api.collaborators.collaborator(medicalProfileId, collaboratorId),
            );
        },
        enabled: !!medicalProfileId && !!collaboratorId,
    });
    useQueryErrorNotify(collaborator, intl('loadError'));

    return {
        collaborator: collaborator.data?.collaborator || null,
        isLoading: collaborator.isLoading,
    };
};
